import geoJSON from 'utils/geoJSON/geoJSON'
import ObjectTools from 'utils/objects/objectTools'

const generalConfig = {
  chart: {
    style: {
      fontFamily: '\'Montserrat\', Helvetica, Arial, sans-serif'
    },
    backgroundColor: 'rgba(255, 0,0, 0.0)',
    marginBottom: 30
  },
  title: {
    text: ''
  },
  credits: {
    enabled: true,
    text: '',
    href: 'https://www.orkestra.deusto.es',
    position: {
      y: -10
    },
    style: {
      fontSize: '12px'
    }
  },
  exporting: {
    sourceWidth: 800,
    sourceHeight: 550,
    buttons: {
      contextButton: {
        enabled: false
      }
    },
    allowHTML: true
  },
  tooltip: {
    enabled: true,
    valueSuffix: '',
    formatter: function() {
      return `<span style="font-weight: bold; font-size: 10px">${this.point.options.countryName}</span><br/> <span>${this.point.options.name} (${
        this.point.options.code
      })</span>`
    },
    style: {
      fontFamily: '\'Montserrat\', Helvetica, Arial, sans-serif'
    }
  },
  mapNavigation: {
    enabled: true,

    buttonOptions: {
      verticalAlign: 'top',
      align: 'left',
      x: -9
    }
  },
  colorAxis: {
    tickPixelInterval: 50,
    startOnTick: false,
    endOnTick: false,
    labels: {
      align: 'right',
      x: 30
    },
    reversed: false
  },
  legend: {
    enabled: false,
    borderWidth: 0,
    padding: 0,
    itemDistance: 2,
    layout: 'vertical',
    align: 'left',
    verticalAlign: 'bottom',
    floating: false
  },

  series: []
}

let selectedRegionConfig = ObjectTools.copyObject(generalConfig)

const chartMapConfig = {
  geoJSON,
  generalConfig,
  selectedRegionConfig
}

export default chartMapConfig



// WEBPACK FOOTER //
// ./src/modules/Charts/Map/HomeMap/HomeMapConfig.js